export default "__VITE_ASSET__CXmNA3zk__"